<template>
  <div class="tabShareOpportunity">
    <div class="alert alert-success" role="alert" v-if="false">
      <span style="font-size:14px;position: relative;top: 0px;"
        ><font-awesome-icon :icon="['fas', 'check-circle']"/></span
      >&nbsp; <strong>Download:</strong>&nbsp;The issue related to the selection
      of images for PDF and Weblinks is now solved.
    </div>
    <h4 class="text-danger">Download</h4>

    <Accordion>
      <TabShareQuotePdf
        v-if="data && data.images && !isTrafalgarRiver"
        :cardSelected="accordionCardSelected"
        card-title="Quote PDF"
        card-name="custom-pdf"
        pdf-content-type="quote_pdf"
        web-content-type="weblink"
        cover-page-name="cover_page"
        image-page-name="images_page"
        :is-agent="false"
        :isCollapsed="accordionCardSelected === 'custom-pdf'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.images"
        :template-setting="data.opportunity_settings"
        @onSelect="onSelectAccordionCard"
        @onEditing="toggleEditing"
      />

      <TabShareWebLink
        card-title="Web link"
        card-name="weblink"
        pdf-content-type="quote_pdf"
        web-content-type="weblink"
        image-field="background"
        :cardSelected="accordionCardSelected"
        :isCollapsed="accordionCardSelected === 'weblink'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.images"
        :template-setting="data.opportunity_settings"
        v-if="data && data.images"
        @onSelect="onSelectAccordionCard"
      />

      <TabShareQuotePdf
        v-if="data && data.images && hasConsumerFacing"
        :cardSelected="accordionCardSelected"
        card-title="Consumer Facing - Quote PDF"
        card-name="agent-custom-pdf"
        image-field="agent_quote_web_link"
        pdf-content-type="agent_quote_pdf"
        web-content-type="agent_weblink"
        cover-page-name="cover_agent_quote_pdf"
        image-page-name="agent_quote_pdf"
        :is-agent="true"
        :isCollapsed="accordionCardSelected === 'agent-custom-pdf'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.images"
        :template-setting="data.opportunity_settings"
        @onSelect="onSelectAccordionCard"
        @onEditing="toggleEditing"
      />

      <TabShareWebLink
        v-if="data && data.images && hasConsumerFacing"
        card-title="Consumer Facing - Web link"
        card-name="proposal"
        pdf-content-type="agent_quote_pdf"
        web-content-type="agent_weblink"
        image-field="agent_quote_web_link"
        :cardSelected="accordionCardSelected"
        :isCollapsed="accordionCardSelected === 'proposal'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.images"
        :template-setting="data.opportunity_settings"
        @onSelect="onSelectAccordionCard"
      />

      <BaseButton
        type="submit"
        classButton="btn btn-icon-box btn-danger btn-labeled mr-2"
        @click="onComplete"
        :disabled="isCompleting || isCompletedQuote || isEditing"
      >
        <span v-if="!isCompleting && !isCompletedQuote"
          >Complete
          <span class="btn-label"
            ><font-awesome-icon :icon="['fas', 'eye']"/></span
        ></span>
        <span v-if="isCompletedQuote"
          >Viewing
          <span class="btn-label"
            ><font-awesome-icon :icon="['fas', 'eye']"/></span
        ></span>
        <span v-if="isCompleting"
          ><font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1"
        /></span>
      </BaseButton>

      <hr class="my-4" />

      <TabShareFlyerPdf
        v-if="data && data.consumer_section && data.consumer_section.images"
        :cardSelected="accordionCardSelected"
        :isCollapsed="accordionCardSelected === 'flyer-pdf'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.consumer_section.images"
        :template-setting="data.opportunity_settings"
        @onSelect="onSelectAccordionCard"
        @onEditing="toggleEditing"
      />

      <TabShareLandingPage
        v-if="data && data.consumer_section && data.consumer_section.images && !isTrafalgarRiver"
        :cardSelected="accordionCardSelected"
        :isCollapsed="accordionCardSelected === 'landing-page'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.consumer_section.images"
        @onSelect="onSelectAccordionCard"
      />

      <TabShareGuestDocumentation
        v-if="data && data.guest_documentation && data.guest_documentation.images  && !isTrafalgarRiver"
        :cardSelected="accordionCardSelected"
        :isCollapsed="accordionCardSelected === 'guest-documentation'"
        :isEditing="isEditing"
        :isCompletedQuote="isCompletedQuote"
        :data="data.guest_documentation.images"
        @onSelect="onSelectAccordionCard"
      />
      <Portal to="modalPortal">
        <Modal :show="isModalShow" @close="onCloseModal">
          <div class="text-center mb-4">
            <font-awesome-icon
              class="text-info"
              :icon="['fas', 'eye']"
              size="4x"
            />
            <h1 class="text-info text-center my-4">Complete Quote</h1>
            <p class="lead mb-5">
              Great! This will finalise the quotation. Have you completed
              Itinerary, Inclusions, Pricing and Terms and Conditions?
            </p>
            <button
              class="btn btn-wide btn-light btn--cancel mr-1 font-weight-bold"
              :disabled="isCompleting"
              @click="onCloseModal"
            >
              No, take me back
            </button>
            <button
              class="btn btn-wide btn-info ml-1 font-weight-bold"
              @click="completeQuote"
              :disabled="isCompleting"
            >
              <span v-if="!isCompleting">Yes, please complete it</span>
              <span v-if="isCompleting">
                <font-awesome-icon
                  class="text-white"
                  :icon="['fas', 'spinner']"
                  spin
                />
              </span>
            </button>
          </div>
        </Modal>
      </Portal>
    </Accordion>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import messageTypes from '@/store/messages/types'
import Accordion from '@/components/_shared/accordion/Accordion.vue'

import TabShareQuotePdf from '@/components/opportunity-edit/TabShareQuotePdf.vue'
import TabShareWebLink from '@/components/opportunity-edit/TabShareWebLink.vue'
import TabShareFlyerPdf from '@/components/opportunity-edit/TabShareFlyerPdf.vue'
import TabShareLandingPage from '@/components/opportunity-edit/TabShareLandingPage.vue'
import Modal from '@/components/_shared/Modal.vue'
import TabShareGuestDocumentation from '@/components/opportunity-edit/TabShareGuestDocumentation.vue'

import ModalMixin from '@/mixins/modal'
import {OPPORTUNITY__BRANDS} from "@/constants";

export default {
  name: 'TabShare',
  mixins: [ModalMixin],
  data () {
    return {
      accordionCardSelected: '',
      isSaving: false,
      isEditing: false,
      isCompleting: false
    }
  },
  components: {
    Accordion,
    TabShareQuotePdf,
    TabShareWebLink,
    TabShareFlyerPdf,
    TabShareLandingPage,
    Modal,
    TabShareGuestDocumentation
  },
  props: {
    isCompletedQuote: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Array, Object],
      required: false
    }
  },
  computed: {
    ...mapGetters({
      getMessage: 'messages/getMessage',
      opportunityData: 'opportunity/opportunity'
    }),
    isTrafalgarRiver() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR_RIVER === this.opportunityData.properties_opportunity.id_brand
      );
    },
    hasConsumerFacing() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR === this.opportunityData.properties_opportunity.id_brand
      );
    },
    isLoadingCompleteQuote () {
      return this.getMessage(messageTypes.isLoadingCompleteQuote).value
    },
    isADraft () {
      if (
        this.opportunityData &&
        this.opportunityData.reference_number === ''
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleEditing () {
      this.isEditing = !this.isEditing
    },
    onSelectAccordionCard (cardName) {
      if (this.accordionCardSelected === cardName) {
        this.accordionCardSelected = ''
        return false
      }
      this.accordionCardSelected = cardName
      this.isEditing = !this.isEditing
      this.$scrollTo('body', { duration: 800, offset: 215 })
    },
    onComplete () {
      this.onShowModal()
    },
    completeQuote () {
      const SALES_QUOTE_SENT = 23

      if (this.isADraft) {
        this.$notification.warning(
          'Please before complete the opportunity you need to add the corresponding "Reference number" inside the option "Details".',
          10000
        )
        return false
      }

      this.$store.commit(
        'opportunity/TEMP_SAVE_COMPLETE_QUOTE',
        SALES_QUOTE_SENT
      )

      this.$store.commit('messages/setMessage', {
        type: messageTypes.isLoadingCompleteQuote,
        value: true
      })

      this.isCompleting = true

      this.togglePreventCloseModal(true)

      this.$store
        .dispatch('opportunity/saveOpportunity')
        .then(response => {
          if (response.data && response.data.uuidOpportunity) {
            const privateId = response.data.uuidOpportunity
            this.$notification.success(
              'Opportunity completed successfully.',
              18000
            )
            this.$notification.warning(
              'Please wait while we are processing the new itineraries.',
              18000
            )
            this.$store
              .dispatch('opportunity/getOpportunity', privateId)
              .then(response => {
                this.togglePreventCloseModal(false)
                this.isCompleting = false
                this.onCloseModal()
                this.$store.commit('messages/setMessage', {
                  type: messageTypes.isLoadingCompleteQuote,
                  value: false
                })
                NProgress.done()
              })
              .catch(error => {
                this.togglePreventCloseModal(false)
                this.isCompleting = false
                this.$store.commit('messages/setMessage', {
                  type: messageTypes.isLoadingCompleteQuote,
                  value: false
                })
                if (error.response && error.response.status > 400) {
                  // 401 || 403
                  // this.$store.dispatch('auth/removeToken')
                }
              })
          } else {
            NProgress.done()
            this.togglePreventCloseModal(false)
            this.isCompleting = false
            this.$store.commit('messages/setMessage', {
              type: messageTypes.isLoadingCompleteQuote,
              value: false
            })
            this.$notification.error(response.message)
          }
        })
        .catch(error => {
          console.log(error)
          this.togglePreventCloseModal(false)
          this.isCompleting = false
          NProgress.done()
          this.$store.commit('messages/setMessage', {
            type: messageTypes.isLoadingCompleteQuote,
            value: false
          })
        })
    }
  }
}
</script>

<style lang="scss">
.alert.alert-warning-alpha {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
  border-radius: 0px;
}
</style>
